import { render } from "./AuthItemGroupIndex.vue?vue&type=template&id=32eb276b&scoped=true"
import script from "./AuthItemGroupIndex.vue?vue&type=script&lang=js"
export * from "./AuthItemGroupIndex.vue?vue&type=script&lang=js"

import "./AuthItemGroupIndex.vue?vue&type=style&index=0&id=32eb276b&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32eb276b"]])

export default __exports__